<template>
    <div v-if="loaded === true">
        <div class="d-flex flex-row time-counter justify-content-between" :class="{expired : expired}" :id="id">
            <div class="d-flex flex-column align-items-center" v-if="availableSection.days === true">
                <span class="font-weight-bold">{{days}}</span>
                <span class="time-counter-hint" v-if="displayHint === true">{{timeNames.days}}</span>
            </div>
            <span class="counter-colon" v-if="availableSection.days === true">:</span>
            <div class="d-flex flex-column align-items-center" v-if="availableSection.hours === true">
                <span class="font-weight-bold">{{hours}}</span>
                <span class="time-counter-hint" v-if="displayHint === true">{{timeNames.hours}}</span>
            </div>
            <span class="counter-colon" v-if="availableSection.hours === true">:</span>
            <div class="d-flex flex-column align-items-center" v-if="availableSection.minutes === true">
                <span class="font-weight-bold">{{minutes}}</span>
                <span class="time-counter-hint" v-if="displayHint === true">{{timeNames.minutes}}</span>
            </div>
            <span class="counter-colon" v-if="availableSection.minutes === true">:</span>
            <div class="d-flex flex-column align-items-center" v-if="availableSection.seconds === true">
                <span class="font-weight-bold">{{seconds}}</span>
                <span class="time-counter-hint" v-if="displayHint === true">{{timeNames.seconds}}</span>
            </div>
        </div>
        <b-tooltip :target="String(id)" triggers="hover" v-if="expired">Время вышло</b-tooltip>
        <b-tooltip :target="String(id)" triggers="hover" v-if="!expired">Время, за которое заказ должен завершиться</b-tooltip>
    </div>
</template>

<script>
export default {
  props: {
    end: {
      type: Date,
      required: true
    },
    displayHint: Boolean,
    availableSection: {
      type: Object,
      default: function () {
        return {
          days: false,
          hours: true,
          minutes: true,
          seconds: true
        }
      }
    }
  },
  data: function () {
    return {
      id: null,
      loaded: false,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      timeNames: {
        days: 'Дней',
        hours: 'Часов',
        minutes: 'Минут',
        seconds: 'Секунд'
      },
      expired: false,
      distance: null
    }
  },
  mounted () {
    this.id = String(this._uid)
    this.showRemaining()
  },
  computed: {
    _seconds: () => 1000,
    _minutes () {
      return this._seconds * 60
    },
    _hours () {
      return this._minutes * 60
    },
    _days () {
      return this._hours * 24
    }
  },
  methods: {
    formatTimerNumber: num => num < 10 ? '0' + num : num,
    showRemaining () {
      const _end = new Date(this.end)
      const _curr = new Date()
      if (_end.getTime() > _curr.getTime()) {
        this.distance = _end.getTime() - _curr.getTime()
        const timer = setInterval(() => {
          this.distance -= 1000
          if (this.distance < 0) {
            clearInterval(timer)
            this.expired = true
            this.loaded = true
            return
          }

          const days = Math.floor(this.distance / this._days)
          const hours = Math.floor((this.distance % this._days) / this._hours)
          const minutes = Math.floor((this.distance % this._hours) / this._minutes)
          const seconds = Math.floor((this.distance % this._minutes) / this._seconds)

          this.days = this.formatTimerNumber(days)
          this.hours = this.formatTimerNumber(hours)
          this.minutes = this.formatTimerNumber(minutes)
          this.seconds = this.formatTimerNumber(seconds)
          this.loaded = true
        }, 1000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .time-counter {
        cursor: pointer;
        font-size: 1rem;
        width: fit-content;
        border-radius: 5px;
        padding: 0.5em 1em;
        background-color: rgb(99, 99, 99);
        color: rgb(255, 255, 255);
        &.expired {
            background-color: #dc3545;

            &:hover {
                background-color: #92202b;
            }
        }
        .time-counter-hint {
            font-size: calc(50%);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/TimeCounter.vue